module.exports = __webpack_public_path__ + "img/home.db6c4c3b.svg";